<template>
  <div class="account-mapping-filters-populations-hover">
    <template v-for="segment in resolvedSegments" :key="segment.type">
      <div
        v-if="segment.populations.length"
        class="account-mapping-filters-populations-hover__segment"
      >
        <p
          v-if="showSegmentHeader"
          class="account-mapping-filters-populations-hover__segment-label"
        >
          {{ segment.label }}
        </p>
        <ul class="account-mapping-filters-populations-hover__list">
          <li
            v-for="pop in segment.populations"
            :key="pop.id"
            class="account-mapping-filters-populations-hover__item"
          >
            <BittsAvatar
              v-if="pop.partnerOrg"
              :org="pop.partnerOrg"
              size="x-small"
              class="shrink-0"
            />
            <DataSourceAvatar
              v-else-if="pop.dataSourceType"
              :data-source="pop.dataSourceType"
              size="x-small"
              class="shrink-0"
            />
            {{ pop.name }}
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { BittsAvatar } from '@crossbeam/bitts';

import DataSourceAvatar from '@/components/DataSourceAvatar.vue';

import { DataSourceType } from '@/types/feeds';
import { SegmentType } from '@/types/populations';

export type ResolvedPopulationSegmentType = {
  type: SegmentType;
  label: string;
  populations: {
    id: number;
    name: string;
    dataSourceType?: DataSourceType;
    partnerOrg?: {
      name?: string;
      domain?: string | null;
      logo_url?: string | null;
      clearbit_domain?: string | null;
    } | null;
  }[];
};

const { showSegmentHeader = true, resolvedSegments = [] } = defineProps<{
  showSegmentHeader?: boolean;
  resolvedSegments?: ResolvedPopulationSegmentType[];
}>();
</script>

<style scoped lang="pcss">
@reference "../../css/theme.css";

.account-mapping-filters-populations-hover {
  @apply p-4 min-w-[200px] max-w-[280px] max-h-[320px] overflow-y-auto flex flex-col gap-8;

  scrollbar-width: thin;
  scrollbar-color: theme(colors.neutral.500) transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    @apply bg-neutral-500 rounded-full;
  }
}

.account-mapping-filters-populations-hover__segment-label {
  @apply font-bold;
}

.account-mapping-filters-populations-hover__list {
  @apply flex flex-col gap-4;
}

.account-mapping-filters-populations-hover__item {
  @apply flex items-center gap-4 text-sm;
}
</style>
